<div class="flex w-full flex-col items-center pb-10 pt-4">
  <!-- Hero -->
  <div
    class="mb-10 flex w-full max-w-[56rem] flex-col items-center gap-4 text-center md:mb-12">
    <div
      class="inline-flex items-center gap-2 rounded-full bg-bn-blue-light px-4 py-1.5 text-sm font-medium text-light-primary">
      <mat-icon class="!h-[14px] !w-[14px] !text-[14px] text-light-primary"
        >school</mat-icon
      >
      Für Schweizer Schulen
    </div>
    <h1 class="m-0 text-page-headline-sm text-slate-900 md:text-page-headline">
      @if (offer()) {
        Ihr persönliches Angebot
      } @else {
        Attraktive Angebote für alle
      }
    </h1>
    <p class="m-0 max-w-2xl text-lg font-light text-slate-500">
      @if (offer()) {
        Dieses Angebot wurde für deine Schule zusammengestellt.
      } @else {
        Starte kostenlos oder wähle das passende Abo für deine Schule.
      }
    </p>

    @if (showPlans()) {
      <div class="mt-2 flex justify-center">
        <div
          class="inline-flex rounded-lg border border-slate-200 bg-white p-1 shadow-sm">
          <button
            type="button"
            class="rounded-md px-6 py-2.5 text-sm font-medium transition-colors"
            [class.bg-light-primary]="selectedDuration === 1"
            [class.text-white]="selectedDuration === 1"
            [class.shadow-sm]="selectedDuration === 1"
            [class.text-slate-600]="selectedDuration !== 1"
            (click)="selectDuration(1)">
            1 Jahr
          </button>
          <button
            type="button"
            class="flex items-center gap-1.5 rounded-md px-5 py-2.5 text-sm font-medium transition-colors"
            [class.bg-light-primary]="selectedDuration === 2"
            [class.text-white]="selectedDuration === 2"
            [class.shadow-sm]="selectedDuration === 2"
            [class.text-slate-600]="selectedDuration !== 2"
            (click)="selectDuration(2)">
            2 Jahre
            <span
              class="text-[10px] font-bold"
              [class.text-green-600]="selectedDuration !== 2"
              [class.text-white]="selectedDuration === 2">
              Spare 5%
            </span>
          </button>
          <button
            type="button"
            class="flex items-center gap-1.5 rounded-md px-5 py-2.5 text-sm font-medium transition-colors"
            [class.bg-light-primary]="selectedDuration === 3"
            [class.text-white]="selectedDuration === 3"
            [class.shadow-sm]="selectedDuration === 3"
            [class.text-slate-600]="selectedDuration !== 3"
            (click)="selectDuration(3)">
            3 Jahre
            <span
              class="text-[10px] font-bold"
              [class.text-green-600]="selectedDuration !== 3"
              [class.text-white]="selectedDuration === 3">
              Spare 10%
            </span>
          </button>
        </div>
      </div>
    }
  </div>

  @if (offer(); as offer) {
    <article
      data-testid="negotiated-offer-card"
      class="w-full max-w-md overflow-hidden rounded-xl border-2 border-light-primary bg-white shadow-[0_8px_10px_rgba(219,234,254,0.4),0_20px_25px_rgba(219,234,254,0.4)]">
      <div class="bg-bn-blue-light/90 px-6 pb-8 pt-8 text-center">
        <p
          class="m-0 text-xs font-bold uppercase tracking-wider text-light-primary">
          Ihr Angebot
        </p>
        <p class="m-0 mt-2 text-lg font-semibold text-slate-900">
          {{ offer.label }}
        </p>
        <p class="m-0 mt-4 text-2xl font-bold text-light-primary">
          {{ formatRappenChf(offer.yearly_price_rappen) }} pro Jahr
        </p>
      </div>
      <div class="space-y-4 px-6 py-8 text-sm leading-relaxed text-slate-600">
        <p class="m-0">
          Mindestlaufzeit {{ offer.contract_years }} Jahre ({{
            offer.contract_start | date: 'dd.MM.yyyy'
          }}
          – {{ offer.contract_end | date: 'dd.MM.yyyy' }}), danach jährliche
          Verlängerung
        </p>
        <p class="m-0">
          Enthalten: Admins {{ limitLabel(offer.user_invitation_left) }} ·
          Schuleinheiten {{ limitLabel(offer.school_unit_creation_left) }} ·
          Standorte {{ limitLabel(offer.sub_school_creation_left) }} ·
          Stelleninserate {{ limitLabel(offer.permanent_job_postings_left) }} /
          Stellvertretungen {{ limitLabel(offer.substitute_job_postings_left) }}
        </p>
          <app-offer-points [points]="offer.customer_notes" />
        <button
          type="button"
          data-testid="accept-offer"
          class="flex w-full items-center justify-center rounded-lg bg-light-primary py-3.5 text-sm font-semibold text-white shadow-sm transition hover:opacity-90"
          (click)="onAcceptOffer()">
          Angebot annehmen
        </button>
      </div>
    </article>
  } @else if (offerLoading()) {
    <div class="flex w-full justify-center py-16">
      <mat-spinner diameter="40" />
    </div>
  } @else {
    <!-- Pricing cards (Figma 58503:16488 — Kostenlos compact height; Schuleinheit Empfohlen + blue header) -->
    <div
      class="relative grid w-full max-w-[56rem] grid-cols-1 items-start gap-6 overflow-visible px-0 md:grid-cols-2 md:gap-8">
      <!-- Kostenlos: top aligns with Schuleinheit card (grid items-start); height from content only -->
      <article
        class="flex w-full max-w-[432px] flex-col self-start rounded-xl border border-slate-200 bg-white p-8 shadow-sm md:max-w-none">
        <h3
          class="m-0 text-center text-xs font-bold uppercase tracking-wider text-slate-400">
          Kostenlos
        </h3>
        <div class="mt-6 flex items-baseline justify-center gap-2">
          <span
            class="text-5xl font-bold leading-none text-slate-900 md:text-[48px]"
            >0</span
          >
          <span class="text-lg font-medium text-slate-400">CHF</span>
        </div>
        <p class="m-0 mt-1 text-center text-xs text-slate-400">pro Monat</p>
        <div class="mt-8 flex flex-col gap-1 text-center">
          <p class="m-0 text-sm text-slate-600">Jetzt ausprobieren</p>
          <p class="m-0 text-xs text-slate-400">
            Einzelinserate kostenpflichtig
          </p>
        </div>
        <div class="mt-8">
          <button
            type="button"
            class="w-full rounded-lg border border-slate-200 bg-slate-50 py-3.5 text-sm font-medium text-slate-700 shadow-sm transition hover:bg-slate-100"
            (click)="pickFree()">
            Kostenlos starten
          </button>
        </div>
      </article>

      <!-- Schuleinheit: same top edge as Kostenlos; chip only overlaps upward from this card -->
      <div
        class="relative w-full max-w-[432px] self-start justify-self-start md:max-w-none md:justify-self-auto">
        <article
          class="relative flex flex-col rounded-xl border border-[#bfdbfe] bg-[rgb(239_246_255_/_0.2)] shadow-[0_8px_10px_rgba(219,234,254,0.4),0_20px_25px_rgba(219,234,254,0.4)]">
          <div
            class="pointer-events-none absolute left-1/2 top-0 z-30 flex -translate-x-1/2 -translate-y-1/2 justify-center">
            <span
              class="pointer-events-auto rounded-full bg-[#1e40af] px-4 py-1.5 text-xs font-semibold text-white shadow-md">
              Empfohlen
            </span>
          </div>
          <!-- Light blue top block: title, price, tagline (Figma 58503:16506) -->
          <div
            class="rounded-t-xl bg-[rgb(239_246_255_/_0.35)] px-8 pb-6 pt-10 text-center">
            <h3
              class="m-0 text-xs font-bold uppercase tracking-wider text-light-primary">
              Schuleinheit
            </h3>
            <div class="mt-4 flex items-baseline justify-center gap-2">
              <span
                class="text-5xl font-bold leading-none text-light-primary md:text-[60px]"
                >49</span
              >
              <span class="text-lg font-medium text-slate-400">CHF</span>
            </div>
            <p class="m-0 mt-1 text-center text-xs text-slate-400">pro Monat</p>
            <p class="m-0 mt-3 text-sm font-light text-slate-500">
              Die flexible Lösung
            </p>
          </div>

          <!-- White block: admin stepper + price summary (Figma 58503:16515) -->
          <div
            class="rounded-b-xl border-t border-[#dbeafe] bg-white px-8 pb-8 pt-8">
            <div class="flex items-center justify-between gap-4">
              <span class="text-sm text-slate-600">Zusätzliche Admins</span>
              <div class="flex items-center gap-0">
                <button
                  type="button"
                  class="flex h-8 w-8 items-center justify-center rounded border border-slate-200 bg-white text-slate-700 hover:bg-slate-50 disabled:opacity-30"
                  [disabled]="extraAdmins <= 0"
                  (click)="decAdmins()">
                  –
                </button>
                <span
                  class="min-w-[2rem] text-center text-base font-medium text-slate-900"
                  >{{ extraAdmins }}</span
                >
                <button
                  type="button"
                  class="flex h-8 w-8 items-center justify-center rounded border border-slate-200 bg-white text-slate-700 hover:bg-slate-50 disabled:opacity-30"
                  [disabled]="extraAdmins >= 50"
                  (click)="incAdmins()">
                  +
                </button>
              </div>
            </div>
            <p class="m-0 mt-1 text-right text-[10px] text-slate-400">
              +9.90 CHF/Monat pro Admin
            </p>

            <div
              class="mt-6 rounded-xl border border-[#dbeafe] bg-[rgb(239_246_255_/_0.45)] px-4 py-4 text-center">
              <p class="m-0 text-xs text-slate-400">Dein Preis:</p>
              <p class="m-0 mt-1 text-2xl font-bold text-light-primary">
                {{ annualTotalChf.toFixed(2) }} CHF
              </p>
              <p class="m-0 mt-1 text-[11px] text-slate-400">für 12 Monate</p>
              @if (discountPercent > 0) {
                <p class="m-0 mt-2 text-xs font-medium text-slate-600">
                  {{ discountPercent }}% Rabatt ({{
                    selectedDuration
                  }}-Jahres-Abo)
                </p>
              }
            </div>

            <button
              type="button"
              class="mt-6 w-full rounded-lg border border-slate-200 bg-white py-3.5 text-sm font-semibold text-slate-800 shadow-sm transition hover:bg-slate-50"
              (click)="pickPaid()">
              Auswählen
            </button>
          </div>
        </article>
      </div>
    </div>

    <!-- Leistungsübersicht -->
    <section class="mt-12 w-full max-w-4xl px-0">
      <button
        type="button"
        class="flex w-full items-center justify-between rounded-xl border border-slate-200 bg-white px-6 py-4 text-left shadow-sm"
        (click)="toggleFeatures()">
        <span class="text-base font-semibold text-slate-700"
          >Leistungsübersicht</span
        >
        <mat-icon
          class="material-symbols-rounded text-slate-600 transition-transform duration-200"
          [class.-scale-y-100]="featuresExpanded">
          expand_more
        </mat-icon>
      </button>

      @if (featuresExpanded) {
        <div
          class="mt-2 overflow-hidden rounded-[14px] border border-slate-200 bg-white shadow-sm">
          <div class="overflow-x-auto">
            <div class="min-w-[320px]">
              <div
                class="grid grid-cols-[minmax(0,1fr)_minmax(5.5rem,7rem)_minmax(5.5rem,7rem)] border-b border-slate-200 bg-slate-50 md:grid-cols-[minmax(0,1fr)_minmax(7rem,9rem)_minmax(7rem,9rem)]">
                <div
                  class="px-4 py-4 text-sm font-semibold text-slate-900 md:px-6">
                  Features
                </div>
                <div
                  class="flex items-center justify-center border-l border-slate-100 px-2 py-4 text-center text-sm font-medium text-slate-500 md:px-3">
                  Kostenlos
                </div>
                <div
                  class="flex items-center justify-center border-l border-slate-100 px-2 py-4 text-center text-sm font-bold text-light-primary md:px-3">
                  Schuleinheit
                </div>
              </div>

              @for (block of tableBlocks; track $index) {
                @switch (block.type) {
                  @case ('employerBanner') {
                    <div
                      class="border-t border-slate-100 bg-gradient-to-r from-blue-50 via-blue-50/90 to-slate-50/40 px-5 py-4 md:px-6">
                      <div class="flex items-center gap-3">
                        <div
                          class="flex h-12 w-12 shrink-0 items-center justify-center rounded-[10px] bg-blue-600 shadow-sm">
                          <mat-icon
                            class="employer-offer-banner__star material-symbols-rounded !text-[28px] leading-none text-white"
                            style="position: relative; left: -1px; top: -2px">
                            star
                          </mat-icon>
                        </div>
                        <div class="min-w-0 space-y-0.5">
                          <p
                            class="m-0 text-sm font-bold leading-snug text-blue-900">
                            {{ block.title }}
                          </p>
                          <p class="m-0 text-xs leading-snug text-blue-700">
                            {{ block.subtitle }}
                          </p>
                        </div>
                      </div>
                    </div>
                  }
                  @case ('section') {
                    <div
                      class="border-t border-slate-200 bg-slate-50/90 px-4 py-3 md:px-6">
                      <p
                        class="m-0 text-xs font-bold uppercase tracking-wide text-slate-400">
                        {{ block.title }}
                      </p>
                    </div>
                  }
                  @case ('row') {
                    <div
                      class="grid grid-cols-[minmax(0,1fr)_minmax(5.5rem,7rem)_minmax(5.5rem,7rem)] border-t border-slate-100 md:grid-cols-[minmax(0,1fr)_minmax(7rem,9rem)_minmax(7rem,9rem)]">
                      <div class="flex flex-col gap-1 px-4 py-4 md:px-6">
                        <span
                          class="text-sm font-medium leading-snug text-slate-700"
                          >{{ block.label }}</span
                        >
                        @if (block.hint) {
                          <span class="text-xs leading-snug text-slate-400">{{
                            block.hint
                          }}</span>
                        }
                      </div>
                      @for (col of [block.free, block.unit]; track $index) {
                        <div
                          class="flex items-center justify-center border-l border-slate-100 px-1 py-4 md:px-2">
                          @switch (col.kind) {
                            @case ('check') {
                              <span
                                class="relative inline-flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-full bg-green-50">
                                <mat-icon
                                  class="material-symbols-rounded absolute left-1/2 top-1/2 flex !h-[14px] !w-[14px] -translate-x-1/2 -translate-y-1/2 items-center justify-center !text-[14px] !leading-none text-green-600">
                                  check
                                </mat-icon>
                              </span>
                            }
                            @case ('cross') {
                              <mat-icon
                                class="material-symbols-rounded !text-[18px] text-slate-400">
                                close
                              </mat-icon>
                            }
                            @case ('premium') {
                              <span
                                class="rounded-full bg-blue-100 px-3 py-1 text-xs font-bold text-light-primary shadow-sm">
                                Premium
                              </span>
                            }
                            @case ('text') {
                              @switch (col.variant) {
                                @case ('blue') {
                                  <span
                                    class="text-center text-sm font-semibold text-light-primary"
                                    >{{ col.text }}</span
                                  >
                                }
                                @case ('muted') {
                                  <span
                                    class="text-center text-xs font-normal leading-snug text-slate-500"
                                    >{{ col.text }}</span
                                  >
                                }
                                @case ('body') {
                                  <span
                                    class="text-center text-sm font-normal text-slate-700"
                                    >{{ col.text }}</span
                                  >
                                }
                              }
                            }
                          }
                        </div>
                      }
                    </div>
                  }
                }
              }
            </div>
          </div>
        </div>
      }
    </section>
  }
</div>
